import EventsApi from "./events";
import TrainingApi from "./training";
import DashboardApi from "./dashboard";

export default { 
    ...EventsApi,
    ...TrainingApi,
    ...DashboardApi,
 };